import React, { useMemo, useState } from 'react';
import classnames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Rating } from 'react-simple-star-rating';
import { CSSTransition } from 'react-transition-group';

import useStaticImage from 'hooks/graphql/useStaticImage';
import updateRating from 'api/updateRating';
import useOptions from 'hooks/graphql/useOptions';

import * as styles from './rating.module.scss';

const RatingComponent = ({ databaseId }) => {
  const getStaticImage = useStaticImage();
  const [rating, setRating] = useState(0);
  const [selectRating, setSelectRating] = useState(false);
  const options = useOptions();

  const { resourceCenterPostInfo } = options.resourceCenterPostInfo;

  const {
    resourceCenterPostInfoTrial: {
      resourceCenterPostInfoTrialTitle,
      resourceCenterPostInfoTrialUrl,
      resourceCenterPostInfoTrialMarketedText,
    },
  } = resourceCenterPostInfo;

  const {
    resourceCenterPostInfoRating: {
      resourceCenterPostInfoRatingTitle,
      resourceCenterPostInfoRatingEvaluationText,
    },
  } = resourceCenterPostInfo;

  const Bad = useMemo(() => {
    return getImage(getStaticImage('common/rating/bad.png').childImageSharp);
  }, [getStaticImage]);

  const Normal = useMemo(() => {
    return getImage(getStaticImage('common/rating/normal.png').childImageSharp);
  }, [getStaticImage]);

  const Good = useMemo(() => {
    return getImage(getStaticImage('common/rating/good.png').childImageSharp);
  }, [getStaticImage]);

  const handleRating = (rate, e) => {
    setRating(rate);

    updateRating(String(rate), String(databaseId)).then(() =>
      console.info('updateRating')
    );

    setSelectRating(!selectRating);
  };

  return (
    <section className={classnames(styles.section)}>
      <div>
        <div className={classnames(styles.head)}>
          <h5 className={classnames('scr-h5')}>
            {resourceCenterPostInfoTrialTitle}
            <a
              href={resourceCenterPostInfoTrialUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={classnames('scr-link scr-blue')}
            >
              {resourceCenterPostInfoTrialMarketedText}
            </a>
          </h5>
        </div>

        <div className={classnames(styles.container)}>
          <CSSTransition
            in={!selectRating}
            classNames="scr-css-transition--fade"
            timeout={{
              enter: 200,
              exit: 250,
            }}
            unmountOnExit
          >
            <>
              <p className={classnames(styles.ratingTitle, 'scr-lead ')}>
                <span className={classnames(styles.ratingTitle_text)}>
                  {resourceCenterPostInfoRatingTitle}
                </span>
              </p>

              <Rating
                onClick={handleRating}
                stars={3}
                ratingValue={rating}
                size={110}
                className={classnames(styles.ratingList)}
              >
                <GatsbyImage image={Bad} alt={''} objectFit="contain" />

                <GatsbyImage image={Normal} alt={''} objectFit="contain" />

                <GatsbyImage image={Good} alt={''} objectFit="contain" />
              </Rating>
            </>
          </CSSTransition>

          <CSSTransition
            in={selectRating}
            classNames="scr-css-transition--fade"
            timeout={{
              enter: 800,
              exit: 850,
            }}
            unmountOnExit
          >
            <p>{resourceCenterPostInfoRatingEvaluationText}</p>
          </CSSTransition>
        </div>
      </div>
    </section>
  );
};

export default RatingComponent;
